import { Link } from "react-router-dom";
import { contactInfo } from "@/mocks/site";

interface CtaBannerProps {
  title?: string;
  description?: string;
}

export default function CtaBanner({
  title = "Ready to Move? Get a Free Quote Today!",
  description = "Get flexible & upgradeable services from Lahari. Experience top quality, tailored and comprehensive moving solutions for your home, office or warehouse.",
}: CtaBannerProps) {
  return (
    <section className="relative overflow-hidden bg-accent-950 py-14 md:py-16">
      <div className="absolute -right-10 top-1/2 h-72 w-72 -translate-y-1/2 rounded-full bg-primary-500/25 blur-3xl" />
      <div className="absolute -left-16 bottom-0 h-56 w-56 rounded-full bg-secondary-500/20 blur-3xl" />
      <div className="relative mx-auto flex max-w-screen-2xl flex-col items-center gap-6 px-4 text-center md:px-6">
        <h2 className="max-w-3xl font-heading text-2xl font-bold text-background-50 md:text-4xl">{title}</h2>
        <p className="max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">{description}</p>
        <div className="flex flex-col gap-3 sm:flex-row">
          <a
            href={contactInfo.phoneHref}
            data-cta="Call"
            data-cta-location="cta-banner"
            className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-phone-fill text-lg" aria-hidden="true" /> Call {contactInfo.phone}
          </a>
          <Link
            to="/request-a-quote"
            data-cta="Request a Free Quote"
            data-cta-location="cta-banner"
            className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-7 py-3.5 text-sm font-semibold text-foreground-950 transition-colors hover:bg-background-200"
          >
            <i className="ri-file-text-line text-lg" aria-hidden="true" /> Request a Free Quote
          </Link>
        </div>
      </div>
    </section>
  );
}